import {Track} from './Track';
import {Category} from './Category';

export class CatTrack {
  track: Track;
  cat: Category[];
}
